/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './rodape.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../app/rodape/rodape.component';
import * as i4 from '../../../app/configs.service';
const styles_RodapeComponent:any[] = [i0.styles];
export const RenderType_RodapeComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_RodapeComponent,data:{}});
export function View_RodapeComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),3,'footer',[['class','footer']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgStyle,[i1.KeyValueDiffers,
      i1.ElementRef,i1.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),i1.ɵpod(['color']),
      (_l()(),i1.ɵted((null as any),['\n    ©',' - PrimeSoftware\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i3.RodapeComponent = _v.component;
    const currVal_0:any = _ck(_v,3,0,_co.corTexto);
    _ck(_v,2,0,currVal_0);
  },(_ck,_v) => {
    var _co:i3.RodapeComponent = _v.component;
    const currVal_1:any = _co.anoAtual;
    _ck(_v,4,0,currVal_1);
  });
}
export function View_RodapeComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-rodape',([] as any[]),
      (null as any),(null as any),(null as any),View_RodapeComponent_0,RenderType_RodapeComponent)),
      i1.ɵdid(114688,(null as any),0,i3.RodapeComponent,[i4.ConfigsService],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const RodapeComponentNgFactory:i1.ComponentFactory<i3.RodapeComponent> = i1.ɵccf('app-rodape',
    i3.RodapeComponent,View_RodapeComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9yb2RhcGUvcm9kYXBlLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9naXRodWIvd29ya3NwYWNlL3NyYy9hcHAvcm9kYXBlL3JvZGFwZS5jb21wb25lbnQudHMiLCJuZzovLy9naXRodWIvd29ya3NwYWNlL3NyYy9hcHAvcm9kYXBlL3JvZGFwZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9yb2RhcGUvcm9kYXBlLmNvbXBvbmVudC50cy5Sb2RhcGVDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8IS0tIEZvb3RlciAtLT5cbjxmb290ZXIgY2xhc3M9XCJmb290ZXJcIiBbbmdTdHlsZV09XCJ7J2NvbG9yJzogY29yVGV4dG99XCI+XG4gICAgJmNvcHk7e3thbm9BdHVhbH19IC0gUHJpbWVTb2Z0d2FyZVxuPC9mb290ZXI+XG48IS0tIEVuZCBGb290ZXIgLS0+IiwiPGFwcC1yb2RhcGU+PC9hcHAtcm9kYXBlPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FlLHVDQUNmO01BQUE7TUFBQSxxQ0FBQTsrQkFBQSxnREFBdUI7TUFBZ0MsaUVBRTlDO1VBQUE7O0lBRmM7SUFBdkIsV0FBdUIsU0FBdkI7OztJQUF1RDtJQUFBOzs7O29CQ0R2RDtNQUFBO2FBQUE7VUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/rodape/rodape.component.ngfactory.ts